// 施設詳細ページのハッシュスクロール共通ユーティリティ
// エリアページの施設カセットから体験談リンク経由で遷移した際に、
// 一度冒頭を表示してから該当セクションへスムーズスクロールする

const EXPERIENCE_HASHES = ['#move-in-experience', '#move-out-experience']

// connect()で呼び出す: ハッシュスクロールの初期化とpageshowイベント登録
export function setupHashScroll (controller) {
  scrollToHashOnLoad(controller)

  // bfcache復元時にも対応（戻る→再クリック時）
  controller.boundPageShow = (event) => {
    if (event.persisted) {
      scrollToHashOnLoad(controller)
    }
  }
  window.addEventListener('pageshow', controller.boundPageShow)
}

// disconnect()で呼び出す: pageshowイベントリスナーの解除
export function teardownHashScroll (controller) {
  if (controller.boundPageShow) {
    window.removeEventListener('pageshow', controller.boundPageShow)
  }
}

function scrollToHashOnLoad (controller) {
  const hash = window.location.hash
  if (!hash) return

  // 体験談セクションへのスクロールのみ対応（他のアンカーはブラウザのデフォルト動作に任せる）
  if (!EXPERIENCE_HASHES.includes(hash)) return

  const element = document.querySelector(hash)
  if (!element) return

  // ブラウザのデフォルトアンカージャンプを防止するためハッシュを一時除去
  history.replaceState(null, '', window.location.pathname + window.location.search)
  window.scrollTo(0, 0)

  // 冒頭表示後、該当セクションへスムーズスクロール
  setTimeout(() => {
    if (!controller.scroll) return
    controller.scroll.animateScroll(element)
  }, 300)
}
